



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  PatientRecord,
  PatientContact,
  PatientProvider,
  ProviderFilter2,
} from "@/store/modules/types";
import {
  required,
  numeric,
  email,
  minLength,
  maxLength,
  minValue,
  maxValue,
  helpers 
} from "vuelidate/lib/validators";
import moment from "moment";
import ModalHeader from "@/components/ModalHeader.vue";
import { BCard, BTabs, BTab, BCardText } from "bootstrap-vue";
import Pager from "@/components/Pager.vue";

const digitsOnly = value => (value || "").replace(/\D/g, "");

const phoneValidator = helpers.withParams(
  { type: "phoneValidator" },
  value => {
    if (!value) return true; 
    return digitsOnly(value).length === 10;
  }
);

@Component({
  components: {
    ModalHeader,
    BCard,
    BTabs,
    BTab,
    BCardText,
    Pager,
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("gaps", ["insurers"]),
    ...mapState("patients", ["phoneStatus"]),
  },
  validations: {
    patient: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      birth: {
        year: {
          numeric,
          required,
        },
        month: {
          numeric,
          minValue: minValue(0),
          maxValue: maxValue(11),
          required,
        },
        day: {
          numeric,
          minValue: minValue(1),
          maxValue: maxValue(31),
          required,
        },
      },
      gender: {
        required,
      },
      countryId: {
        required,
      },
     /*  phone: {
        mobile: {
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(10),
        },
        mobileStatusId: {
          minLength: minLength(2),
          maxLength: maxLength(2),
        },
        home: {
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(10),
        },
        homeStatusId: {
          minLength: minLength(2),
          maxLength: maxLength(2),
        },
        other: {
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(10),
        },
        otherStatusId: {
          minLength: minLength(2),
          maxLength: maxLength(2),
        },
        other2: {
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(10),
        },
        other2StatusId: {
          minLength: minLength(2),
          maxLength: maxLength(2),
        },
      }, */
      phone: {
  mobile: {
    phoneValidator,
  },
  mobileStatusId: {
    minLength: minLength(2),
    maxLength: maxLength(2),
  },
  home: {
    phoneValidator,
  },
  homeStatusId: {
    minLength: minLength(2),
    maxLength: maxLength(2),
  },
  other: {
    phoneValidator,
  },
  otherStatusId: {
    minLength: minLength(2),
    maxLength: maxLength(2),
  },
  other2: {
    phoneValidator,
  },
  other2StatusId: {
    minLength: minLength(2),
    maxLength: maxLength(2),
  },
},
      email: {
        email,
      },
      lang: {
        required,
      },
    },
    patientContact: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      typeId: {
        required,
      },
      relationId: {
        required,
      },
      phone: {
        /*numeric,
        minLength: minLength(10),
        maxLength: maxLength(10)*/
      },
      email: {
        email,
      },
    },
  },
})
export default class PatientEditor extends Vue {
  @Prop(String) readonly modalName!: string;
  @Prop(Number) readonly patientId!: number;
  patient: PatientRecord = {
    id: null,
    firstName: "",
    lastName: "",
    lastName2: "",
    birth: {
      year: "",
      years: [],
      month: "",
      monthDays: [],
      day: "",
      date: "",
    },
    gender: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
    countryId: "",
    insurerId: "",
    insurerMemberId: "",
    contactName: "",
    phone: {
      mobile: "",
      mobileStatusId: "OK",
      home: "",
      homeStatusId: "OK",
      other: "",
      otherStatusId: "OK",
      other2: "",
      other2StatusId: "OK",
    },
    pcpProviderName: "",
    pcpProviderId: "",
    email: "",
    EMR_ID: "",
    lang: "",
    contacts: [],
    providers: [],
    ipaName: "",
    ipaNumber: ""
  };
  patientContact: PatientContact = {
    id: null,
    typeId: "",
    relationId: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
  };
  patientProvider: PatientProvider = {
    id: null,
    name: "",
    npi: "",
    phone: "",
    specialtyId: null,
  };
  providerFilter: ProviderFilter2 = {
    name: "",
    npi: "",
    specialtyId: "",
    pageNumber: 1,
    rowsPerPage: 25,
  };
  providerFilterDefault: ProviderFilter2 = {
    name: "",
    npi: "",
    specialtyId: "",
    pageNumber: 1,
    rowsPerPage: 200,
  };
  providers = [];
  providerList: Array<any> = [];
  contactRelations = {};
  contactTypes = {};
  providerPageRows: Array<any> = [];
  providerTotalRows: number = 0;
  @Watch("patient.birth", { deep: true })
  onPatientBirthChanged(birth: any, oldVal: any) {
    const birthdate = moment([birth.year, birth.month, birth.day]);
    this.patient.birth.date = birthdate.isValid()
      ? birthdate.format("YYYY-MM-DD").toString()
      : "";
  }
  async getPatient() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "patients/getPatient",
        this.patientId
      );
      this.patient.id = data.id;
      this.patient.firstName = data.firstName;
      this.patient.lastName = data.lastName;
      this.patient.lastName2 = data.lastName2;
      // BIRTHDATE
      this.patient.birth.year = moment(data.birthdate).year().toString();
      this.patient.birth.month = moment(data.birthdate).month().toString();
      this.patient.birth.day = moment(data.birthdate).date().toString();
      this.setBirthMonthDays();
      //
      this.patient.gender = data.gender;
      // ADDRESS
      this.patient.addressLine1 = data.addressLine1;
      this.patient.addressLine2 = data.addressLine2;
      this.patient.city = data.city;
      this.patient.state = data.state;
      this.patient.zip = data.zip;
      this.patient.countryId = data.countryId;
      //
      this.patient.insurerId = data.insurerId ? data.insurerId : "";
      this.patient.insurerMemberId = data.insurerMemberId
        ? data.insurerMemberId
        : "";
      this.patient.contactName = data.contactName ? data.contactName : "";
      // PHONES
      this.patient.phone.mobile = data.mobilePhone;
      this.patient.phone.mobileStatusId = data.mobilePhoneStatusId;
      this.patient.phone.home = data.homePhone;
      this.patient.phone.homeStatusId = data.homePhoneStatusId;
      this.patient.phone.other = data.otherPhone;
      this.patient.phone.otherStatusId = data.otherPhoneStatusId;
      this.patient.phone.other2 = data.otherPhone2;
      this.patient.phone.other2StatusId = data.otherPhone2StatusId;
      // PCP
      this.patient.pcpProviderName = data.pcpProviderName;
      this.patient.pcpProviderId = data.pcpProviderId;
      //
      this.patient.email = data.email;
      this.patient.EMR_ID = data.EMR_ID;
      //
      this.patient.ipaName = data.ipaName;
      this.patient.ipaNumber = data.ipaNumber;
      //
      this.patient.lang = data.lang;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getPatientContacts() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "patients/getContacts",
        this.patientId
      );
      this.patient.contacts = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getContactRelations() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("patients/getContactRelations");
      this.contactRelations = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getContactTypes() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("patients/getContactTypes");
      this.contactTypes = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getPatientProviders() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "patients/getProviders",
        this.patientId
      );
      this.patient.providers = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getProviders() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "providers/getList",
        this.providerFilter
      );
      this.providers = data;
      this.providerTotalRows = data.totalRows;
      this.providerPageRows = data.pageRows;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getProviderList() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "providers/getList",
        this.providerFilterDefault
      );
      this.providerList = data.pageRows;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async save() {
    if (this.$v.patient && this.$v.patient.$invalid) {
      this.$v.patient.$touch();
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      if (!this.patient.id && this.patient.EMR_ID) {
        const exists = await this.$store.dispatch(
          "patients/emrIdExists",
          this.patient.EMR_ID
        );
        if (exists) {
          this.$modal.show("dialog", {
            title: "WaitingMed",
            text: `A patient with <b>EMR record</b> '${this.patient.EMR_ID}' already exists.`,
          });
          return;
        }
      }
      await this.$store.dispatch("patients/save", this.patient);
      this.$emit("patient-saved");
      this.close();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveContact() {
    if (this.$v.patientContact && this.$v.patientContact.$invalid) {
      this.$v.patientContact.$touch();
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      var patientId = this.patientId;
      var contact = this.patientContact;
      await this.$store.dispatch("patients/saveContact", {
        contact,
        patientId,
      });
      this.$modal.hide("patient-contact");
      this.getPatientContacts();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async archiveContact(contact) {
    this.$modal.show("dialog", {
      title: "Remove " + contact.firstName + " " + contact.lastName,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$store.commit("main/SET_LOADING", true);
            try {
              var patientId = this.patientId;
              await this.$store.dispatch("patients/archiveContact", {
                contact,
                patientId,
              });
              this.$modal.hide("dialog");
              this.getPatientContacts();
            } catch (error) {
              console.log(error);
            } finally {
              this.$store.commit("main/SET_LOADING", false);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  async archiveProvider(provider) {
    this.$modal.show("dialog", {
      title: "Remove " + provider.name,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$store.commit("main/SET_LOADING", true);
            try {
              var patientId = this.patientId;
              await this.$store.dispatch("patients/archiveProvider", {
                provider,
                patientId,
              });
              this.$modal.hide("dialog");
              this.getPatientProviders();
            } catch (error) {
              console.log(error);
            } finally {
              this.$store.commit("main/SET_LOADING", false);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  async saveProvider(provider) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      var patientId = this.patientId;
      await this.$store.dispatch("patients/saveProvider", {
        provider,
        patientId,
      });
      this.$modal.hide("providers");
      this.getPatientProviders();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  setBirthYears() {
    let year = moment().year() - 110;
    while (year <= moment().year()) {
      this.patient.birth.years.push(year);
      year++;
    }
  }
  setBirthMonthDays() {
    this.patient.birth.monthDays = [];
    const { year, month } = this.patient.birth;
    if (year === "" || month === "") {
      return;
    }
    const days = moment([year, month]).daysInMonth();
    for (let i = 1; i <= days; i++) {
      this.patient.birth.monthDays.push(i);
    }
  }
  editContact(contact) {
    if (contact) {
      this.patientContact.id = contact.id;
      this.patientContact.typeId = contact.typeId;
      this.patientContact.relationId = contact.relationId;
      this.patientContact.firstName = contact.firstName;
      this.patientContact.lastName = contact.lastName;
      this.patientContact.phone = contact.phone;
      this.patientContact.email = contact.email;
    } else {
      this.patientContact.id = null;
      this.patientContact.typeId = "";
      this.patientContact.relationId = "";
      this.patientContact.firstName = "";
      this.patientContact.lastName = "";
      this.patientContact.phone = "";
      this.patientContact.email = "";
    }

    this.$modal.show("patient-contact");
  }
  addProvider() {
    this.$modal.show("providers");
  }
  rowsPerPageChanged(rowsPerPage: number) {
    this.providerFilter.rowsPerPage = rowsPerPage;
    this.getProviders();
  }
  pageChanged(page: number) {
    this.providerFilter.pageNumber = page;
    this.getProviders();
  }
  close() {
    this.$modal.hide(this.modalName || "patient-editor");
    this.$emit("closed");
  }
  mounted() {
    this.setBirthYears();
    this.getContactRelations();
    this.getContactTypes();
    this.getProviderList();
    if (this.patientId) {
      this.getPatient();
      this.getPatientContacts();
      this.getPatientProviders();
      this.getProviders();
    }
  }
}
